import MUITooltip, { TooltipProps } from '@mui/material/Tooltip';

const Tooltip = (props: TooltipProps) => {
  return <MUITooltip {...props} />;
};

export default Tooltip;
